import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import moment from "moment";
import swal from "sweetalert";
import { Modal } from 'bootstrap';

import Loader from "../../../components/ui/Loader/Loader";
import TapIcon from '../../../services/TapIcon';
import { DisplayListPagination } from '../../../components/TapUi';
import Status from '../../../components/ui/Status';
import HttpAPICall from '../../../services/HttpAPICall';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import download from '../../../services/DownloadFile';
import ScsExecutionHistoryView from '../../transactions/scsExecutionHistory/ScsExecutionHistoryView';
import ExecutedServiceChecksheetDetail from './ExecutedServiceChecksheetDetail';
import ServiceChecksheet from '../../assets/counterlog/ShiftActivityModals/ServiceChecksheet';

function ScsTab(props) {
    const access_token = useSelector(state => state.auth.access_token);
    const permissions = useSelector(state => state.app.acl_info?.permissions || []);
    const scsDetailRef = useRef(null);
    const scsExecutionRef = useRef(null)

     const [ticketData, setTicketData] = useState(null);
     const [assetId,setAssetId]     =   useState(null);

    const [listingData, setListingData] = useState({
        loading: false,
        history: [],
        meta: null,
        reportDownloading: false
    });

   
    const loadListingTblData = (page = 1) => {
        
        setListingData(prev => ({ ...prev, loading: true }));
        let params = {
            page: page,
            search_ticket_id : props.ticketData ? props.ticketData.activity_id : null,
            search_asset_ids: props.ticketData && props.ticketData.asset ? [props.ticketData.asset.asset_id] : [],
            get_asset_profile: "Y"
        };
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/scs/execution_history', access_token, { ...params }, {},
            (response) => {
                let respData = response.data;
                setListingData(prev => ({
                    ...prev,
                    history: respData.data || [],
                    meta: {
                        current_page: respData.current_page || 1,
                        from: respData.from || 0,
                        last_page: respData.last_page || 1,
                        to: respData.to || 0,
                        total: respData.total || 0
                    },
                    loading: false
                }));
            },
            (error) => {
                setListingData(prev => ({ ...prev, loading: false }));
            }
        );
    };

    useEffect(() => {
        if (props.ticketData) {
            loadListingTblData(1);
        }
    }, [props.ticketData]);

    if (!props.ticketData) {
        return (
            <div className="text-center p-4">
                <p>No SCS associated with this ticket</p>
            </div>
        );
    }

    const serviceChecksheetViewInit = (id) => {
        scsDetailRef.current.scsDetaildata(id)
    }

    const addServiceChecksheetInit = () => {
        scsExecutionRef.current.serviceChecksheetModalInit(null, null, props.ticketData?.asset, props.ticketData);
    }


    const deleteScsExecution = (id) => {
        swal({
            title: "Delete",
            text: "Are you sure want to delete this execution of this service checksheet permanently?",
            icon: "warning",
            // dangerMode: true,
            buttons: ["No", "Yes"],
        })
            .then(willDelete => {
                if (willDelete) {
                    HttpAPICall.withAthorization('DELETE', IAM_API_BASE_URL_2 + '/scs/execution_delete/' + id, access_token,{},{},(resp) => {
                        toast.success(resp.data.msg, {position: toast.POSITION.TOP_RIGHT});
                        loadListingTblData(1)
                    });
                }
            });
    }

    const  deleteLinkJsx                       =   (transaction_id)  =>  {
        return <a role="button" 
            onClick={() => { if(permissions.includes('iam-asset-scs-execute-delete'))  { 
                    return deleteScsExecution(transaction_id) 
                } }} 
            className={['dropdown-item', permissions.includes('iam-asset-scs-execute-delete') ? '' : 'disabled'].join(' ')} 
            title={!permissions.includes('iam-asset-scs-execute-delete') ? 'You do not have permission to perform this action' : ''} 
            style={{"pointerEvents" : "all"}}
        >Delete</a>;
    }
    const executionHistoryTableJsx = () => {
        return (
            <>
                <div className='table-responsive' style={{ maxHeight: "400px", overflowY: "auto" }}>
                    <table className="table table-bordered bg-white table-fixed table-hover" id="assetExecutionHistoryTable">
                        <thead className="table-secondary">
                            <tr>
                                <th scope="col" style={{ width: "5%" }} className="text-center">S.No</th>
                                <th scope="col" style={{ width: "12%" }}>Transaction Date</th>
                                <th scope="col" style={{ width: "12%" }}>Transaction Id</th>
                                <th scope="col" style={{ width: "23%" }}>CheckSheet Name</th>
                                <th scope="col" style={{ width: "13%" }} className="text-center">Executed Site</th>
                                <th scope="col" style={{ width: "14%" }}>Parameter</th>
                                <th scope="col" style={{ width: "16%" }}>CounterLog</th>
                                <th scope="col" style={{ width: "5%" }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listingData.loading ? (
                                <tr>
                                    <td className="text-center" colSpan="8"><Loader /></td>
                                </tr>
                            ) : (
                                listingData.history && listingData.history.length > 0 ? (
                                    listingData.history.map((scs, index) => {
                                        return (
                                            <tr key={scs.id}>
                                                <td className='text-center'>{index + 1}</td>
                                                <td className='text-center'>{scs.feed_datetime ? moment(scs.feed_datetime).format('DD MMM YYYY') : '-'}</td>
                                                <td>
                                                    <a role="button" className="link-primary" onClick={() => serviceChecksheetViewInit(scs.id)}>
                                                        {scs.transaction_id}
                                                    </a>
                                                </td>
                                                <td className='text-center'>{scs.scs_setting?.alias_name ? scs.scs_setting?.alias_name : "-"}</td>
                                                <td>{scs.site ? scs.site.site_name : "-"}</td>
                                                <td>
                                                    {scs.parameter && scs.parameter.execute_display && scs.parameter.execute_display
                                                        ? <div>
                                                            <Status color={scs.parameter.execute_display.color}>
                                                                {scs.parameter.type === "range" ? scs.parameter.execute_level : scs.parameter.execute_display.text}
                                                            </Status>
                                                            {scs.parameter.type === "range" ? <div className='my-1'>{scs.parameter.type_display}</div> : null}
                                                        </div>
                                                        : 'NA'}
                                                </td>
                                                <td className="text-start">
                                                    {scs.counterlog && scs.counterlog.length > 0
                                                        ? scs.counterlog.map((item, idx) => (
                                                            <div key={idx} className="mt-1">
                                                                {item.label} : {item.reading} {item.unit} <br />
                                                            </div>
                                                        ))
                                                        : "-"}
                                                </td>
                                                <td>
                                                    <TapIcon.imageIcon
                                                        icon={TapIcon.ListActionIcon}
                                                        alt="action-icon"
                                                        className="img-fluid px-3"
                                                        data-bs-toggle="dropdown"
                                                        href="#"
                                                        role="button"
                                                        aria-expanded="false"
                                                    />
                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                        <li>
                                                            <button className="dropdown-item" role="button" onClick={() => serviceChecksheetViewInit(scs.id)} >
                                                                View Execution
                                                            </button>
                                                        </li>
                                                         <li>
                                                            {deleteLinkJsx(scs?.id)}
                                                         </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center">No Records</td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
                {listingData.meta && listingData.meta.last_page > 1 && (
                    <div className='mx-3 my-1'>
                        <DisplayListPagination
                            meta={listingData.meta}
                            onPageChange={(e) => loadListingTblData(e.selected + 1)}
                        />
                    </div>
                 )}
            </>
        );
    };
   

    return (
        <>
        <div className="px-3 pb-3 bg-white">
            <div style={{ paddingTop: "4px" }}>
                <div className="page_title row m0" style={{ height: "45px" }}>
                        <div className="tab_content_wrapper mt-2 d-flex align-items-center justify-content-between">
                            <span className="content_heading">Executed Checksheet</span>
                           {props.ticketData && props.ticketData.asset && props.ticketData.start_date && <button onClick={addServiceChecksheetInit} type="button" className="btn btn-primary ms-1">
                                <TapIcon.FontAwesomeIcon icon={TapIcon.faPlus} className="img-fluid mr3" alt="item-action" />
                            </button>}
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl0 pr13">
                <div className="page_containt row">
                    <div className="col-12 pr0">
                        {executionHistoryTableJsx()}
                    </div>
                </div>
            </div>
        </div>
        <ServiceChecksheet ref={scsExecutionRef} afterDeleteServiceChecksheet={() => {
                       loadListingTblData(1)
                    }} afterSaveServiceChecksheet={() => {
                       loadListingTblData(1)
                    }} />
                    <ExecutedServiceChecksheetDetail ref={scsDetailRef}/>
        </>
    );
}

export default ScsTab;